import type { DesignFile } from "./types";

export const VIDEO_EXTENSIONS = new Set(["mov", "mp4"]);

export function isVideoDesign(design: DesignFile): boolean {
  return VIDEO_EXTENSIONS.has(design.extension.toLowerCase());
}
